import { useQuery } from '@tanstack/react-query';
import { getProfiles } from '@tectonic/remix-client-network';
import { usePageFragment } from '../../../hooks';
import { useFragmentValue } from '../../../hooks/useFragmentValue';
import { queryKeys } from '../../../queryKeys';

import type { ElemasonUserProfilesWidget } from '@tectonic/types';

const useProfiles = (widget: ElemasonUserProfilesWidget) => {
  const wData = widget.data!;

  const fragment = usePageFragment(wData.fragment);
  const fragmentValue = useFragmentValue(fragment);

  const { data: response, isLoading } = useQuery({
    queryKey: queryKeys.profiles(),
    // Take pagination params as widget data if needed.
    queryFn: () => getProfiles({ page: 1, perPage: 50 }),
  });

  const profiles = response?.data?.hits ?? [];

  return { fragment, fragmentValue, isLoading, profiles };
};

export { useProfiles };
